/**
 * @generated SignedSource<<0b298ac6e09acbcdc9dfd5a37f69525d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RecordLiveMeetingModalMutation$variables = {
  location: string;
  meetingLink: string;
};
export type RecordLiveMeetingModalMutation$data = {
  readonly recordLiveMeeting: {
    readonly callProvider: string;
    readonly eventGuid: string;
  } | null;
};
export type RecordLiveMeetingModalMutation = {
  response: RecordLiveMeetingModalMutation$data;
  variables: RecordLiveMeetingModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "location"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingLink"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "location",
        "variableName": "location"
      },
      {
        "kind": "Variable",
        "name": "meetingLink",
        "variableName": "meetingLink"
      }
    ],
    "concreteType": "RecordLiveMeeting",
    "kind": "LinkedField",
    "name": "recordLiveMeeting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "callProvider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventGuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RecordLiveMeetingModalMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RecordLiveMeetingModalMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "522234004e4e3899b7032a4d5624a685",
    "id": null,
    "metadata": {},
    "name": "RecordLiveMeetingModalMutation",
    "operationKind": "mutation",
    "text": "mutation RecordLiveMeetingModalMutation(\n  $meetingLink: String!\n  $location: String!\n) {\n  recordLiveMeeting(meetingLink: $meetingLink, location: $location) {\n    callProvider\n    eventGuid\n  }\n}\n"
  }
};
})();

(node as any).hash = "9235310799ec42d637a522c55e047b4c";

export default node;
